export default "__VITE_ASSET__2a0b6094__"